import React from 'react';
import { ExternalLink } from 'lucide-react';
import { affiliateLinks } from '../data/mock';

export const AffiliatesSection = () => {
  const affiliates = [
    {
      ...affiliateLinks.heymondo,
      logo: 'https://customer-assets.emergentagent.com/job_bc81a99d-52aa-4670-bd05-bad277666170/artifacts/ccd9rydt_IMG_3092.png'
    },
    {
      ...affiliateLinks.holafly,
      logo: 'https://customer-assets.emergentagent.com/job_bc81a99d-52aa-4670-bd05-bad277666170/artifacts/4mhsuzkl_IMG_3093.jpeg'
    },
    {
      ...affiliateLinks.getyourguide,
      logo: 'https://customer-assets.emergentagent.com/job_bc81a99d-52aa-4670-bd05-bad277666170/artifacts/6e0u196v_IMG_3095.png'
    },
    {
      ...affiliateLinks.go12,
      logo: 'https://customer-assets.emergentagent.com/job_bc81a99d-52aa-4670-bd05-bad277666170/artifacts/s08lx42w_IMG_3094.png'
    }
  ];

  return (
    <section className="py-16 bg-gradient-to-br from-gray-50 to-gray-100">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
            Descuentos exclusivos para viajeros
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Aprovecha estos descuentos especiales en los servicios esenciales para tu viaje
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-5xl mx-auto">
          {affiliates.map((affiliate, index) => {
            return (
              <a
                key={index}
                href={affiliate.url}
                target="_blank"
                rel="noopener noreferrer"
                className="group bg-white rounded-2xl p-6 shadow-sm hover:shadow-xl transition-all duration-300 hover:-translate-y-1"
              >
                <div className="flex items-start gap-4">
                  <div className="w-16 h-16 rounded-xl bg-white border border-gray-200 flex items-center justify-center flex-shrink-0 p-3 group-hover:scale-110 transition-transform duration-300">
                    <img src={affiliate.logo} alt={affiliate.name} className="w-full h-full object-contain" />
                  </div>
                  
                  <div className="flex-1">
                    <div className="flex items-start justify-between mb-2">
                      <h3 className="text-xl font-bold text-gray-900 group-hover:text-orange-600 transition-colors">
                        {affiliate.name}
                      </h3>
                      <ExternalLink className="w-5 h-5 text-gray-400 group-hover:text-orange-600 transition-colors" />
                    </div>
                    
                    {affiliate.discount && (
                      <div className="inline-block bg-gradient-to-r from-orange-400 to-red-500 text-white text-sm font-bold px-3 py-1 rounded-full mb-2">
                        {affiliate.discount}
                      </div>
                    )}
                    
                    <p className="text-gray-600 text-sm mb-3">
                      {affiliate.description}
                    </p>
                    
                    {affiliate.code && (
                      <div className="bg-gray-50 rounded-lg p-3 border border-dashed border-gray-300">
                        <p className="text-xs text-gray-500 mb-1">Código de descuento:</p>
                        <p className="font-mono font-bold text-gray-900">{affiliate.code}</p>
                      </div>
                    )}
                  </div>
                </div>
              </a>
            );
          })}
        </div>
        
        <div className="mt-8 text-center">
          <p className="text-sm text-gray-500">
            Al usar estos enlaces nos ayudas a mantener la comunidad activa sin costo adicional para ti ❤️
          </p>
        </div>
      </div>
    </section>
  );
};
